import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgNetwork(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "network_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#network_svg__a)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, {
      children: [_jsx("path", {
        d: "M22.24 25.093c4.447 0 8.052-3.645 8.052-8.14 0-4.496-3.605-8.14-8.053-8.14-4.447 0-8.053 3.644-8.053 8.14 0 4.495 3.606 8.14 8.053 8.14zM26.204 60c5.687 0 8.382-2.972 9.173-7.605.79-4.633 1.058-6.525 1.91-12.092 1.036-6.71-2.322-10.194-8.877-10.194H16.09c-6.571 0-9.93 3.484-8.91 10.194.858 5.568 1.114 7.459 1.916 12.092C9.898 57.028 12.582 60 18.268 60h7.936z",
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M47.578 14.065c2.75 0 4.98-2.253 4.98-5.032 0-2.78-2.23-5.033-4.98-5.033-2.75 0-4.978 2.253-4.978 5.033 0 2.779 2.229 5.032 4.978 5.032zM44.129 37.871h5.9c3.52 0 5.186-1.84 5.676-4.706.49-2.865.651-4.03 1.18-7.475.641-4.149-1.436-6.322-5.49-6.322h-7.63c-4.055 0-6.127 2.156-5.492 6.305",
        stroke: "#FF6652"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgNetwork;